
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pvc/windows/gealan/[slug]",
      function () {
        return require("private-next-pages/pvc/windows/gealan/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pvc/windows/gealan/[slug]"])
      });
    }
  